import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { useDocumentTitle, useProduct, useScrollTop } from 'hooks';
import PropType from 'prop-types';
import React, { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, withRouter, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { editProduct } from 'redux/actions/productActions';
import { ADMIN_PRODUCTS } from 'constants/routes';

const ProductForm = lazy(() => import('components/product/ProductForm'));

const EditProduct = ({ match }) => {
  const { t } = useTranslation();
  const history = useHistory();
  useDocumentTitle(t('titleEditProduct'));
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const { product, error, isLoading } = useProduct(match.params.id);
  const store = useSelector((state) => ({
    user: state.auth
  }));
  const dispatch = useDispatch();

  const onSubmitForm = (updates) => {
    dispatch(editProduct(product.id, updates));
  };

  return (
    <div className="product-form-container">
      {error && <Redirect to={ADMIN_PRODUCTS} />}
      {product && store.user.id !== product.userId && (
        <Redirect to={ADMIN_PRODUCTS} />
      )}
      <h2>{t('editProductMainMessage')}</h2>
      {product && (
        <Suspense
          fallback={
            <div className="loader" style={{ minHeight: '80vh' }}>
              <h6>{t('loadingMessage')}</h6>
              <br />
              <LoadingOutlined />
            </div>
          }
        >
          <ProductForm
            isLoading={isLoading}
            onSubmit={onSubmitForm}
            isNew={false}
            product={product}
            isAdmin
          />
        </Suspense>
      )}
      <br />
      <button
        className="button button-muted w-100-mobile"
        disabled={isLoading}
        onClick={() => history.push(ADMIN_PRODUCTS)}
        type="button"
      >
        <ArrowLeftOutlined />
        &nbsp; {t('errorButtonBack')}
      </button>
    </div>
  );
};

EditProduct.propTypes = {
  match: PropType.shape({
    params: PropType.shape({
      id: PropType.string
    })
  }).isRequired
};

export default withRouter(EditProduct);
